import React from "react";
import TemplateView from "../../TemplateView";

function View(props) {
    return (
        <TemplateView
            group="Master"
            subgroup="Siswa"
        />
    );
};

export default View;